// extracted by mini-css-extract-plugin
module.exports = {"dialog-video":"DialogVideo_dialog-video__ys5Uv"};